// @flow
import { StateEmtpyActionTypes } from "./constants";

export const stateEmptyActions = () => ({
    type: StateEmtpyActionTypes.STATE_EMPTY_FIRST,
});

